import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";

export const FlashPayService = {


    /**
    * [HAS_ACCOUNT]
    */
    HasAccount() {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }
        return FlashPayService.Common.Fetch(Config.service.flashPay.withdrawal.hasAccount, requestOptions);
    },
    Login(data) {
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return FlashPayService.Common.Fetch(Config.service.flashPay.withdrawal.login, requestOptions);
    },
    /**
  * [HAS_ACCOUNT_DEPOSIT]
  */
    HasAccountDeposit() {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }
        return FlashPayService.Common.Fetch(Config.service.flashPay.deposit.hasAccount, requestOptions);
    },
    LoginDeposit(data) {
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return FlashPayService.Common.Fetch(Config.service.flashPay.deposit.login, requestOptions);
    },
    /**
     * [COMMON]
     * @function Fetch
     */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        UserService.Logout();
                        window.location.reload();
                    }
                    else {
                        throw new Error();
                    }
                }).then((json) => {

                    return json;

                }).catch(function () {
                    return false;
                });

        }
    }
}
